import { useTranslation } from '@mint-lib/i18n';
import { WarningFilled } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';

export const FooterTabEmptyState = () => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <div className="flex flex-1 flex-col items-center justify-center p-8 text-center">
      <div
        className="mb-4 rounded-full border-8"
        style={{ borderColor: 'rgba(110, 222, 245, 0.20)' }}
      >
        <div className="flex h-[26px] w-[26px] items-center justify-center rounded-full border border-info-main">
          <WarningFilled className="fill-info-main" />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <h6 className={typographyVariants({ variant: 'h6', color: 'info' })}>
          {t("Footer rows can't be removed.")}
        </h6>
        <p
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
            className: 'max-w-[320px]',
          })}
        >
          {t(
            "Footer trimming cannot be applied because the file doesn't contain enough data rows after the selected header.",
          )}
        </p>
      </div>
    </div>
  );
};

export default FooterTabEmptyState;
